import { MessageBox, Loading } from 'element-ui';
import router from "../router/router"
import { avg } from "../services/Manage_average.service";
import moment from "moment"
const state = {
    loading: false,
    form: {
        service_name: "",
        voice_service_rate: 0,
        sms_service_rate: 0,
        mms_service_rate: 0,
        internet_service_rate: 0,
        start_date: "",
        end_date: ""
    },
    total: 0,
    data_table: []
};
const actions = {
    async add_average({ commit }, data) {
        let loadingInstance = Loading.service({ fullscreen: true, text: "ระบบกำลังประมวลผล กรุณารอสักครู่ ...", background: "rgb(0, 0, 0,0.6)" });
        let result = await avg.addAvgtosaveService(data);
        if (result.status === 200) {
            setTimeout(function() { loadingInstance.close() }, 250)
            MessageBox.confirm('จัดเก็บข้อมูลเรียบร้อย', 'แจ้งเตือน', {
                confirmButtonText: 'ตกลง',
                showCancelButton: false,
                type: 'success'
            }).then(() => {
                commit('RESET_FORM');
                router.push({ name: 'Manage_average' })
            }).catch(() => {
                router.push({ name: 'Manage_average' })
            });
        } else {
            setTimeout(function() { loadingInstance.close() }, 250)
            MessageBox.confirm(result.message, 'แจ้งเตือน', {
                confirmButtonText: 'ตกลง',
                showCancelButton: false,
                type: 'warning'
            })
        }
    },
    async listAverage({ commit }, data) {
        state.data_table = []
        state.loading = true;
        let loadingInstance = Loading.service({ fullscreen: true, text: "ระบบกำลังประมวลผล กรุณารอสักครู่ ...", background: "rgb(0, 0, 0,0.6)" });
        let result = await avg.listAverage({ page: data.page, pageSize: data.pageSize });
        if (result.status === 200) {
            state.total = result.data.length != 0 ? result.data[0].total : 0;
            setTimeout(() => {
                loadingInstance.close()
                for (var i = 0; i < result.data.length; i++) {
                    commit('UPDATE_TABLE', result.data[i])
                }
                state.loading = false;
            }, 500);
        } else {
            setTimeout(function() { loadingInstance.close() }, 250)
            MessageBox.confirm(result.message, 'แจ้งเตือน', {
                confirmButtonText: 'ตกลง',
                showCancelButton: false,
                type: 'warning'
            })
        }
    },
    async update({ commit }, data) {
        if(!data.service_name){
            return MessageBox.confirm('กรุณากรอกชื่ออัตราการกำกับดูแล', 'แจ้งเตือน', {
                confirmButtonText: 'ตกลง',
                showCancelButton: false,
                type: 'warning'
            })
        }
        let loadingInstance = Loading.service({ fullscreen: true, text: "ระบบกำลังประมวลผล กรุณารอสักครู่ ...", background: "rgb(0, 0, 0,0.6)" });
        let result = await avg.update(data);
        if (result.status === 200) {
            setTimeout(function() { loadingInstance.close() }, 250)
            MessageBox.confirm('จัดเก็บข้อมูลเรียบร้อย', 'แจ้งเตือน', {
                confirmButtonText: 'ตกลง',
                showCancelButton: false,
                type: 'success'
            }).then(() => {
                router.push({ name: 'Manage_average' })
            }).catch(() => {
                router.push({ name: 'Manage_average' })
            });
        } else {
            setTimeout(function() { loadingInstance.close() }, 250)
            MessageBox.confirm(result.message, 'แจ้งเตือน', {
                confirmButtonText: 'ตกลง',
                showCancelButton: false,
                type: 'warning'
            })
        }
    },
    async deleteData({ commit }, data) {
        let dataSet = { id: data.id }
        let result = await avg.deleteData(dataSet);
        if (result.status === 200) {
            MessageBox.confirm('ลบข้อมูลเรียบร้อย', 'แจ้งเตือน', {
                confirmButtonText: 'ตกลง',
                showCancelButton: false,
                type: 'success'
            }).then(() => {
                commit('CUT_TABLE', data.id)
            }).catch(() => {
                commit('CUT_TABLE', data.id)
            });
        } else {
            MessageBox.confirm(result.message, 'แจ้งเตือน', {
                confirmButtonText: 'ตกลง',
                showCancelButton: false,
                type: 'warning'
            })
        }
    }
};

const mutations = {
    UPDATE_TABLE(state, data) {
        state.data_table.push({
            namePromotion: data.service_name,
            minute: data.voice_service_rate,
            price_sms: data.sms_service_rate,
            price_mms: data.mms_service_rate,
            internet: data.internet_service_rate,
            date_first: moment(data.start_date),
            date_final: moment(data.end_date),
            id: data.id
        })
    },
    CUT_TABLE(state, data) {
        let index = state.data_table.findIndex(x => x.id === data);
        state.data_table.splice(index, 1)
    },
    RESET_FORM(state) {
        state.form = {
            service_name: "",
            voice_service_rate: 0,
            sms_service_rate: 0,
            mms_service_rate: 0,
            internet_service_rate: 0,
            start_date: "",
            end_date: ""
        }
    }

};

export const Manage_average = {
    namespaced: true,
    state,
    actions,
    mutations
};